import { Spinner } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import SignInCta from '../../../home/sign-in-cta/sign-in-cta.component';
import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { useSetCurrentUserAsSender } from './set-current-user-as-sender.controller';

const ID = 'set-current-user-as-sender';

export const SetCurrentUserAsSender = () => {
    const viewProps = useSetCurrentUserAsSender();
    const showSignIn = !viewProps.isAuthenticated && !viewProps.isProcessing && !viewProps.isIdentifying;
    const showSpinner = viewProps.isProcessing || viewProps.isIdentifying;

    return (
        <WizardScreenContainer
            id={ID}
            loadingModal={{
                show: showSpinner
            }}
            errorModal={{
                show: !!viewProps.error,
                title: CommonMessage.ERRORS.DEFAULT,
                message: viewProps.error,
                onClose: viewProps.resetError
            }}>
            {showSignIn ? (
                <div className='flex size-full items-center justify-center'>
                    <SignInCta
                        theme='light'
                        title={
                            <FormattedMessage
                                id='kiosk.wizard.set-current-user-as-sender.scan-badge-title'
                                description='Title shown on the set current user as sender screen when the user must identify themselves'
                                defaultMessage='Scan your badge to continue'
                            />
                        }
                    />
                </div>
            ) : showSpinner ? (
                <div className='flex size-full items-center justify-center'>
                    <Spinner className='text-border-default fill-brand-primary size-12' />
                </div>
            ) : null}
        </WizardScreenContainer>
    );
};
